import { useNavigate } from "react-router-dom";
import { useApi } from "../../contexts/ApiContext";
import SetupScreen from "../setup/SetupScreen";
import { createBracket } from "../../utils/bracketLogic";
import {
  createDoubleBracket,
  serializeDouble,
} from "../../utils/doubleElimination";

// Sets up a new tournament, saves its initial bracket, then hands off to the
// live play route (so it's resumable from the start).
function CreateTournamentTab() {
  const navigate = useNavigate();
  const { tournamentsApi } = useApi();

  async function handleStart(names, tournament, ranked, format = "single") {
    let bracketState;
    if (format === "double") {
      bracketState = JSON.stringify({
        format: "double",
        de: serializeDouble(createDoubleBracket(names)),
      });
    } else {
      bracketState = JSON.stringify({
        format: "single",
        rounds: createBracket(names),
      });
    }

    await tournamentsApi.update(tournament.id, {
      ...tournament,
      status: 1,
      format,
      bracketState,
    });

    navigate(`/app/play/${tournament.id}`);
  }

  return <SetupScreen onStart={handleStart} />;
}

export default CreateTournamentTab;
